<template>
	<div @click="toDetails" class="video-card flex between">
		<div class="img">
			<img :src="videoInfo.cover" alt />
		</div>
		<div class="flex start-v">
			<p class="title">{{videoInfo.name}}</p>
			<p class="desc">{{videoInfo.remarks}}</p>
		</div>
		<!-- <button @click.stop="$emit('delete')" class="flex">删除</button> -->
	</div>
</template>

<script>
export default {
	props: {
		videoInfo:{}
	},
	data() {
		return {};
	},
	methods: {
		toDetails(){
			this.$router.push(`/student/videos/details?videosId=${this.videoInfo.id}&type=0`)
		},
	},
};
</script>

<style lang="less" scoped>
.video-card {
	letter-spacing: 1 / @rem;
	padding: 0/@rem 0 15 / @rem;
	position: relative;
	button{
		font-size: 13/@rem;
		color: rgba(255, 162, 22, 1);
		position: absolute;
		right: 13/@rem;
		top: 11/@rem;
		&::before{
			content: "";
			display: inline-block;
			width: 13/@rem;
			height: 13/@rem;
			margin-right: 1/@rem;
			background-image: url(~@img/icon/bnt_delete.png);
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center;
		}
	}
	.start-v {
		flex: 1;
		height: 100%;
		align-items: flex-start;
		p {
			&.title {
				line-height: 35 / @rem;
				font-size: 17 / @rem;
				color: rgba(49, 49, 49, 1);
				font-weight: bold;
				display: -webkit-box;
				word-break: break-all;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 1;
				overflow: hidden;
			}
			&.desc {
				line-height: 18 / @rem;
				font-size: 13 / @rem;
				color: rgba(49, 49, 49, 0.5);
				display: -webkit-box;
				// word-break: break-all;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}
		}
	}
	img {
		min-width: 126 / @rem;
		width: 126 / @rem;
		height: 70 / @rem;
		margin-right: 13 / @rem;
		border-radius: 2 / @rem;
		display: inline-block;
		background-color: #bbbbbb;
	}
}
</style>
